

<template>
  <div class="category">
    <h6>Выберите сотрудников</h6>
    <el-cascader
        class="cascade"
        v-loading="loading"
        :options="filteredOptions"
        :props="props"
        @change="handleChange"
        collapse-tags
        collapse-tags-tooltip
        clearable
    />
  </div>
</template>

<script>
export default {
  name: "custom-cascader-agent-categories",
  components: {},
  props: {
    propsGetSelectedCategoryAndEmployee:{},
    getCategory:{
      type:Function
    },
    single: false
  },
  data() {
    return {
      loading: false,
      options: [
        {
          label: '',
          value: '1',
          children: [
            {
              label: '',
              value: '2',
            }
          ]
        },
      ],
      props : { multiple: !this.single },
      agents: null
    }
  },
  mounted() {
    this.getAgentsWithCategories()
  },
  watch: {},
  computed: {
    filteredOptions() {
      let filteredOptions = []

      if (this.agents) {
        this.agents.forEach(agent => {
          let categoriesObj = []
          let agentObj = {
            value: agent.agent_name,
            label: agent.agent_name,
            children: []
          }
          agent.categories.forEach( category =>{
            categoriesObj.push({value: category.id, label: category.name, option: category.name})
          })
          agentObj.children = categoriesObj;
          filteredOptions.push(agentObj)
        })
      }
      return filteredOptions
    }
  },
  methods: {
    getAgentsWithCategories() {
      this.loading = true;
      this.$api.location.getAgentsWithCategories()
          .then(data => {
            this.agents = data
          })
          .finally(() => {
            this.loading = false;
          })
    },
    handleChange(value) {
      console.log(this.filteredOptions)
      let filteredCategory = []
      value.forEach(el => {
        filteredCategory.push([el[1], el[0]])
      })
      this.getCategory(filteredCategory);

      if(this.single){
        this.propsGetSelectedCategoryAndEmployee({
          employee:value[0],
          category:value[1],
          categoryName: this.getCategoryName(value)
        })
      }
    },
    getCategoryName(value) {
      let category = null;
      const agent = this.agents.find(item =>item.agent_name === value[0])
      if(agent) {
        category = agent.categories.find(category => category.id === value[1])
        return category.name
      }
    }
  }
}

</script>


<style lang="scss" scoped>
.category {
  flex-basis: 75%;
  h6 {
    font-size: 15px;
    margin-bottom: 10px;
    color: #555;
  }

  div {
    display: flex;
    align-items: center;
    line-height: 1;
    gap: 10px;

    p {
      margin: 0;
      font-weight: bold;
      color: #555;

    }
  }

}

</style>